import { NgClass } from '@angular/common';
import { Component, DestroyRef, inject, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
	Validators,
} from '@angular/forms';
import { ButtonComponent } from '@webapp/ui';

@Component({
	selector: 'app-add-security-code',
	standalone: true,
	imports: [ReactiveFormsModule, FormsModule, NgClass, ButtonComponent],
	templateUrl: './add-security-code.component.html',
	styleUrl: './add-security-code.component.scss',
})
export class AddSecurityCodeComponent {
	submitted = signal(false);
	EventSecurityCode = output<string>();
	securityCodeForm: FormGroup = new FormGroup({
		securityCode: new FormControl('', [
			Validators.required,
			Validators.max(9999),
		]),
	});

	setSecurityCode() {
		this.submitted.set(true);
		if (!this.securityCodeForm.valid) return;
		const securityCode =
			this.securityCodeForm.controls['securityCode'].value ?? '';
		this.EventSecurityCode.emit(securityCode.toString());
	}

	shouldShowError(controlName: string, errorName: string): boolean {
		const control = this.securityCodeForm.get(controlName);

		return (
			((control?.touched ?? false) && (control?.dirty ?? false)) &&
			(control?.hasError(errorName) ?? false)
		);
	}
}
